import React, { useState } from "react";
import { useFormik } from "formik";
import { Form, Input, Button, Card, Row, Col, Typography, Spin, message } from "antd";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { updatePassword } from "../redux/AuthController";

const UpdatePassword = () => {
  const { Title } = Typography;
  const loggedInUser = useSelector((state) => state?.authentication?.userAuth);
  const userId = loggedInUser?.obj?.id ?? loggedInUser?.id;
  const dispatch = useDispatch();
  const [showSpinner, setShowSpinner] = useState(false);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: userId,
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      oldPassword: Yup.string().required("Old Password is required"),
      newPassword: Yup.string()
        .required("Password is required")
        .test(
          "not-same-as-old",
          "New password cannot be the same as your old password",
          function (value) {
            const { oldPassword } = this.parent;
            if (!value || !oldPassword) return true;
            return value !== oldPassword;
          },
        ),
      confirmPassword: Yup.string()
        .required("Confirm Password is required")
        .oneOf([Yup.ref("newPassword")], "Password & Confirm Password do not match"),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        setShowSpinner(true);
        const result = await dispatch(
          updatePassword({
            oldPassword: values.oldPassword,
            newPassword: values.newPassword,
          }),
        );
        if (updatePassword.fulfilled.match(result)) {
          message.success("Your password was updated successfully.");
          resetForm({
            values: {
              id: userId,
              oldPassword: "",
              newPassword: "",
              confirmPassword: "",
            },
          });
        } else if (updatePassword.rejected.match(result)) {
          message.error("Could not update password. Please try again.");
        }
      } catch (error) {
        message.error("Could not update password. Please try again.");
      } finally {
        setShowSpinner(false);
      }
    },
  });
  const isPasswordMatch =
    formik.values.newPassword === formik.values.confirmPassword;
  const updateButtonDisabled = !isPasswordMatch;
  const passwordMismatchMessage = !isPasswordMatch && (
    <div className="text-danger text-end">
      Password & Confirm Password do not match!
    </div>
  );

  return (
    <Row justify="center" align="middle" style={{ backgroundColor: "#fff" }}>
      <Col xs={24} sm={20} md={16} lg={12} xl={10}>
        <Card
          bordered={false}
          style={{ boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}
        >
          <Title
            level={2}
            style={{ textAlign: "center", color: "#00ADEF", marginBottom: 20 }}
          >
            Update Password
          </Title>
          <Form layout="vertical" onFinish={formik.handleSubmit}>
            <input type="hidden" name="id" value={loggedInUser.id} />
            <Form.Item
              label="Old Password"
              validateStatus={formik.errors.oldPassword ? "error" : ""}
              help={formik.errors.oldPassword}
            >
              <Input.Password
                name="oldPassword"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.oldPassword}
              />
            </Form.Item>

            <Form.Item
              label="New Password"
              validateStatus={formik.errors.newPassword ? "error" : ""}
              help={formik.errors.newPassword}
            >
              <Input.Password
                name="newPassword"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.newPassword}
              />
            </Form.Item>

            <Form.Item
              label="Confirm Password"
              validateStatus={formik.errors.confirmPassword ? "error" : ""}
              help={formik.errors.confirmPassword}
            >
              <Input.Password
                name="confirmPassword"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.confirmPassword}
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                block
                disabled={showSpinner || updateButtonDisabled}
              >
                {showSpinner ? <Spin size="small" /> : "Update Password"}
              </Button>
            </Form.Item>
            {passwordMismatchMessage && (
              <div style={{ color: "red", textAlign: "center" }}>
                {passwordMismatchMessage}
              </div>
            )}
          </Form>
        </Card>
      </Col>
    </Row>
  );
};
export default UpdatePassword;
